import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { getApplicationConfig } from 'config'

declare global {
  interface Window {
    zE: (command: string, ...args: any[]) => void
  }
}

export const ZendeskWidget: React.FC = () => {
  const { i18n } = useTranslation()
  const { zendesk } = getApplicationConfig()

  useEffect(() => {
    // remove existing script if present
    const existingScript = document.getElementById('ze-snippet')
    if (existingScript) {
      document.body.removeChild(existingScript)
    }

    // add Zendesk Widget script
    const script = document.createElement('script')
    script.id = 'ze-snippet'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendesk.widgetKey}`
    script.async = true

    script.onload = () => {
      if (i18n.resolvedLanguage) {
        // set the language for Zendesk Widget
        window.zE('messenger:set', 'locale', i18n.resolvedLanguage)
      }
    }

    document.body.appendChild(script)

    // cleanup on unmount
    return () => {
      const zendeskScript = document.getElementById('ze-snippet')
      if (zendeskScript) {
        document.body.removeChild(zendeskScript)
      }
    }
  }, [i18n.resolvedLanguage])

  return null
}
